import React from 'react';
import { Modal } from 'react-bootstrap';

interface CaremapprModalProps {
  id: string;
  show: boolean;
  header?: React.ReactNode;
  showCloseButton?: boolean;
  onHide?: () => void;
  animation?: boolean;
  size?: 'sm' | 'lg';
  centered?: boolean;
  body?: React.ReactNode;
  bodyClassName?: string;
}
const CaremapprModal = ({
  show,
  id,
  onHide,
  animation = true,
  size = 'lg',
  centered = true,
  body,
  showCloseButton,
  header,
  bodyClassName,
}: CaremapprModalProps) => {
  return (
    <Modal
      id={id}
      show={show}
      onHide={onHide}
      animation={animation}
      size={size}
      centered={centered}
    >
      {header && (
        <Modal.Header closeButton={showCloseButton}>{header}</Modal.Header>
      )}
      <Modal.Body className={bodyClassName}>{body}</Modal.Body>
    </Modal>
  );
};

export default CaremapprModal;
